export const fontWeight = {
  book: '400',
  regular: '450',
  medium: '530',
}
